<div id="actionItemPanelList" *ngIf="actionItemSearchResult != undefined && isPanelListDataAvailable">
    <app-panel-list [panelList]="actionItemPanelListData" [noResultFound] = "noData" (selectedItems)="getSelectedItems($event)">
      <ng-template #templateRef let-data="dataVar">
        <div class="card">
          <div class="card-container">
            <div class="flex">
              <div class="overflow-ellipse flex-initial flex underline actionItem-header font-semibold blue-color float-right">
                <b pTooltip="{{ data.number }} {{ data.changeControlTitle }} {{ ' > ' }} {{ data?.title }}">
                  <a style="cursor: pointer" (click)="openChangeControl(data?.changeControlNumber)">{{ data?.number }}
                    {{ data?.changeControlTitle }} {{ ' > ' }} {{ data?.title }}
                  </a></b>
              </div>
              <div class="flex-initial flex justify-content-center font-semibold icon-alignment">
                <b><i class="pi pi-circle-fill green-button " [ngClass]="calculateStatusColor(data.status)"></i></b> &nbsp;
                <div class="iconAlignment">
                  {{displayStatusLabelWithDate(data?.status, data.completionDate, data.dueDate, data.statusName)}} &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #templateRef let-data="dataVar">
        <div class="grid">
          <div class="col-fixed" style="width: 15%">
            <div class="font-semibold mb-1">Assigned User</div>
            <div class="content-wrap">
              <app-read-only 
                    [ngClass]="{'inActiveGroup':data?.assignedUserInformation.isTerminated===true}"
                    readonlyText="{{ data?.assignedUser }}"></app-read-only>              
            </div>
          </div>
          <div class="col-fixed" style="width: 15%">
            <div class="font-semibold mb-1">Verifier</div>
            <div class="content-wrap">
              <app-read-only 
                    [ngClass]="{'inActiveGroup':data?.verifierInformation?.isTerminated===true}"
                    readonlyText="{{ data?.verifier }}"></app-read-only> 
            </div>
          </div>
          <div class="col-fixed" style="width: 20%">
            <div class="font-semibold mb-1">Implementation Owner(s)</div>
            <ul>
              <li class="content-wrap" *ngFor="let owner of data?.implementationOwnersInformation">
                <app-read-only 
                    [ngClass]="{'inActiveGroup':owner.isTerminated===true}"
                    readonlyText="{{ owner.name }}"></app-read-only>
              </li>
            </ul>
          </div>
          <div class="col-fixed" style="width: 15%">
            <div class="font-semibold mb-1">Type</div>
            <div class="content-wrap">
              {{ data?.typeName }}
            </div>
          </div>
          <div class="col-fixed" style="width: 34%">
            <div class="font-semibold mb-1">Description</div>
            <div class="content-wrap">
              {{ data?.description }}
            </div>
          </div>
        </div>
      </ng-template>
    </app-panel-list>
  </div>